export default __webpack_public_path__ + "static/media/img-hero-mobile-04-bassic.de4c06a9.jpg";